var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIxVismaWhiteLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 404.923,
    height: 33.253,
    viewBox: "0 0 404.923 33.253",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.551,
    y1: -2.474,
    x2: -0.045,
    y2: -0.295,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    stopColor: "#fffd9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06ba98"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7225",
    "data-name": "Group 7225",
    transform: "translate(-38.065 -1075.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ix-logo-horiz",
    transform: "translate(38.065 1075.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4052",
    "data-name": "Group 4052",
    transform: "translate(37.824)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4029",
    "data-name": "Group 4029"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4027",
    "data-name": "Group 4027",
    transform: "translate(0 5.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3632",
    "data-name": "Path 3632",
    d: "M27.5,4.762a.939.939,0,0,1,.962-.962h0a.939.939,0,0,1,.962.962V22.9a.939.939,0,0,1-.962.962h0A.939.939,0,0,1,27.5,22.9Z",
    transform: "translate(-27.5 -3.8)",
    fill: "#fbfbfc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4028",
    "data-name": "Group 4028"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3633",
    "data-name": "Path 3633",
    d: "M27.5.962A.939.939,0,0,1,28.462,0h0a1.062,1.062,0,0,1,1.1.962V1.1a.939.939,0,0,1-.962.962h0a.939.939,0,0,1-.962-.962V.962Z",
    transform: "translate(-27.5)",
    fill: "#fbfbfc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4030",
    "data-name": "Group 4030",
    transform: "translate(71.179 5.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3634",
    "data-name": "Path 3634",
    d: "M79.3,4.762a.939.939,0,0,1,.962-.962h0a.939.939,0,0,1,.962.962V22.9a.939.939,0,0,1-.962.962h0A.939.939,0,0,1,79.3,22.9Z",
    transform: "translate(-79.3 -3.8)",
    fill: "#fbfbfc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4031",
    "data-name": "Group 4031",
    transform: "translate(71.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3635",
    "data-name": "Path 3635",
    d: "M79.3.962A.939.939,0,0,1,80.262,0h0a.939.939,0,0,1,.962.962V1.1a.939.939,0,0,1-.962.962h0A.939.939,0,0,1,79.3,1.1Z",
    transform: "translate(-79.3)",
    fill: "#fbfbfc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4033",
    "data-name": "Group 4033",
    transform: "translate(137.686 5.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4032",
    "data-name": "Group 4032"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3636",
    "data-name": "Path 3636",
    d: "M137.456,3.8A9.943,9.943,0,0,0,127.7,13.831v.137h0v15.94a1.791,1.791,0,1,0,3.573,0V21.8h0a9.322,9.322,0,0,0,6.046,2.2,9.943,9.943,0,0,0,9.756-10.031A9.777,9.777,0,0,0,137.456,3.8Zm0,16.214a6.016,6.016,0,0,1-5.909-6.183,5.915,5.915,0,1,1,11.817,0A6.016,6.016,0,0,1,137.456,20.014Z",
    transform: "translate(-127.7 -3.8)",
    fill: "#fbfbfc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4035",
    "data-name": "Group 4035",
    transform: "translate(47.682 5.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4034",
    "data-name": "Group 4034"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3637",
    "data-name": "Path 3637",
    d: "M71.956,24.037A9.976,9.976,0,0,1,62.2,13.868a9.765,9.765,0,1,1,19.512,0A9.976,9.976,0,0,1,71.956,24.037Zm0-18.138a7.832,7.832,0,0,0-7.695,7.97,7.7,7.7,0,1,0,15.39,0A7.832,7.832,0,0,0,71.956,5.9Z",
    transform: "translate(-62.2 -3.7)",
    fill: "#fbfbfc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4037",
    "data-name": "Group 4037",
    transform: "translate(76.4 5.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4036",
    "data-name": "Group 4036"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3638",
    "data-name": "Path 3638",
    d: "M92.994,24.037A10,10,0,0,1,83.1,13.868,10,10,0,0,1,92.994,3.7a9.572,9.572,0,0,1,6.733,2.748A1.069,1.069,0,0,1,98.215,7.96a7.835,7.835,0,0,0-5.359-2.2,7.948,7.948,0,0,0-7.832,7.97,7.859,7.859,0,0,0,7.832,7.97,8.1,8.1,0,0,0,5.359-2.2,1.069,1.069,0,0,1,1.512,1.512A9.009,9.009,0,0,1,92.994,24.037Z",
    transform: "translate(-83.1 -3.7)",
    fill: "#fbfbfc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4039",
    "data-name": "Group 4039",
    transform: "translate(95.913 5.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4038",
    "data-name": "Group 4038"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3639",
    "data-name": "Path 3639",
    d: "M107.056,24.037A9.976,9.976,0,0,1,97.3,13.868a9.765,9.765,0,1,1,19.512,0v.687a.939.939,0,0,1-.962.962H99.636a7.907,7.907,0,0,0,7.558,6.321,7.13,7.13,0,0,0,3.71-.962,1.014,1.014,0,1,1,.962,1.786A8.84,8.84,0,0,1,107.056,24.037ZM99.361,13.456h15.39a7.7,7.7,0,0,0-15.39,0Z",
    transform: "translate(-97.3 -3.7)",
    fill: "#fbfbfc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4041",
    "data-name": "Group 4041",
    transform: "translate(26.795 5.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4040",
    "data-name": "Group 4040"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3640",
    "data-name": "Path 3640",
    d: "M65.825,3.937a1.068,1.068,0,0,0-1.374.412l-7.7,16.214h-.137L48.924,4.35a.953.953,0,0,0-1.374-.412.953.953,0,0,0-.412,1.374L55.932,23.45q.206.412.412.412h.824c.137-.137.412-.275.412-.412L66.375,5.312A1,1,0,0,0,65.825,3.937Z",
    transform: "translate(-47 -3.8)",
    fill: "#fbfbfc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4043",
    "data-name": "Group 4043",
    transform: "translate(5.909 5.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4042",
    "data-name": "Group 4042"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3641",
    "data-name": "Path 3641",
    d: "M41.968,4.075A10.712,10.712,0,0,0,34,7.785h0V4.762A.98.98,0,0,0,32.9,3.8a1.062,1.062,0,0,0-1.1.962V23.038h0A.98.98,0,0,0,32.9,24h0A1.084,1.084,0,0,0,34,22.9V13.694a7.975,7.975,0,0,1,15.94,0V22.9a1.182,1.182,0,0,0,1.1,1.1,1.084,1.084,0,0,0,1.1-1.1V13.694A10.135,10.135,0,0,0,41.968,4.075Z",
    transform: "translate(-31.8 -3.8)",
    fill: "#fbfbfc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4045",
    "data-name": "Group 4045",
    transform: "translate(161.183 5.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4044",
    "data-name": "Group 4044"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3642",
    "data-name": "Path 3642",
    d: "M158.541,4.629a9.221,9.221,0,0,0-3.848-.824,10.022,10.022,0,0,0-6.046,2.061h0A2.071,2.071,0,0,0,147,3.8a1.886,1.886,0,0,0-2.2,1.924V21.8a2.071,2.071,0,0,0,1.649,2.061,1.886,1.886,0,0,0,2.2-1.924V13.7a6.13,6.13,0,0,1,6.046-6.183,5.39,5.39,0,0,1,2.473.55,1.966,1.966,0,0,0,2.611-1.1A2.311,2.311,0,0,0,158.541,4.629Z",
    transform: "translate(-144.8 -3.789)",
    fill: "#fbfbfc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4047",
    "data-name": "Group 4047",
    transform: "translate(176.848 5.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4046",
    "data-name": "Group 4046"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3643",
    "data-name": "Path 3643",
    d: "M165.956,24.037A9.976,9.976,0,0,1,156.2,13.868a9.765,9.765,0,1,1,19.512,0v.687a1.819,1.819,0,0,1-1.786,1.786H160.46a6.165,6.165,0,0,0,5.634,3.848,5.884,5.884,0,0,0,3.023-.824,1.7,1.7,0,0,1,2.473.687,1.844,1.844,0,0,1-.687,2.611A9.3,9.3,0,0,1,165.956,24.037Zm-5.909-11.543h11.817a6.157,6.157,0,0,0-5.909-4.809,6.041,6.041,0,0,0-5.909,4.809Z",
    transform: "translate(-156.2 -3.7)",
    fill: "#fbfbfc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4049",
    "data-name": "Group 4049",
    transform: "translate(199.597 5.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4048",
    "data-name": "Group 4048"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3644",
    "data-name": "Path 3644",
    d: "M187.657,13.456h0a.426.426,0,0,0-.275-.137c-.137,0-.137,0-.275-.137a.48.48,0,0,1-.275-.137c-.137,0-.412-.137-.55-.137s-1.1-.275-2.2-.55c-1.512-.412-3.16-.687-4.535-1.1a22.324,22.324,0,0,0-2.611-.55h0l-.137-.137c.137-1.237,2.2-3.023,4.809-3.023a5.488,5.488,0,0,1,4.535,2.473,2.22,2.22,0,0,0,2.473.962,1.789,1.789,0,0,0,.962-2.748,9.525,9.525,0,0,0-7.97-4.535c-4.26,0-8.382,3.023-8.657,6.6a4.04,4.04,0,0,0,1.237,3.16,2.874,2.874,0,0,0,.824.55h0c.137,0,.137.137.275.137a.426.426,0,0,1,.275.137.48.48,0,0,1,.275.137c.137,0,.412.137.55.137s1.1.275,2.2.55c1.512.412,3.16.687,4.535,1.1a22.326,22.326,0,0,0,2.611.55h0l.137.137c-.137,1.237-2.2,3.023-4.809,3.023a5.488,5.488,0,0,1-4.535-2.473,2.225,2.225,0,0,0-2.611-.962,1.842,1.842,0,0,0-.824,2.748,9.525,9.525,0,0,0,7.97,4.535c4.26,0,8.382-3.023,8.657-6.6a4.04,4.04,0,0,0-1.237-3.16C188.207,13.868,187.932,13.594,187.657,13.456Z",
    transform: "translate(-172.756 -3.7)",
    fill: "#fbfbfc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4051",
    "data-name": "Group 4051",
    transform: "translate(219.247 5.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4050",
    "data-name": "Group 4050"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3645",
    "data-name": "Path 3645",
    d: "M201.957,13.456h0a.426.426,0,0,0-.275-.137.426.426,0,0,1-.275-.137.48.48,0,0,1-.275-.137c-.137,0-.412-.137-.55-.137s-1.1-.275-2.2-.55c-1.512-.412-3.16-.687-4.535-1.1a22.325,22.325,0,0,0-2.611-.55h0l-.137-.137c.137-1.237,2.2-3.023,4.809-3.023a5.488,5.488,0,0,1,4.535,2.473,2.22,2.22,0,0,0,2.473.962,1.789,1.789,0,0,0,.962-2.748,9.525,9.525,0,0,0-7.97-4.535c-4.26,0-8.382,3.023-8.657,6.6a4.04,4.04,0,0,0,1.237,3.16,2.874,2.874,0,0,0,.824.55h0c.137,0,.137.137.275.137s.137,0,.275.137a.48.48,0,0,1,.275.137c.137,0,.412.137.55.137s.962.275,2.2.55c1.512.412,3.16.687,4.535,1.1a22.325,22.325,0,0,0,2.611.55h0l.137.137c-.137,1.237-2.2,3.023-4.809,3.023a5.488,5.488,0,0,1-4.535-2.473,2.225,2.225,0,0,0-2.611-.962,1.842,1.842,0,0,0-.824,2.748,9.525,9.525,0,0,0,7.97,4.535c4.26,0,8.382-3.023,8.657-6.6a4.04,4.04,0,0,0-1.237-3.16A2.113,2.113,0,0,1,201.957,13.456Z",
    transform: "translate(-187.056 -3.7)",
    fill: "#fbfbfc"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3646",
    "data-name": "Path 3646",
    d: "M124.27,13.845l5.771-7.008A1.858,1.858,0,1,0,127.155,4.5L121.8,10.96h0l-5.222-6.321a2.111,2.111,0,0,0-2.611-.55,1.788,1.788,0,0,0-.55,2.748l5.909,7.008h0l-5.771,7.008a1.858,1.858,0,1,0,2.886,2.336l5.359-6.458h0l5.359,6.458a1.992,1.992,0,0,0,2.886.137,1.881,1.881,0,0,0,0-2.473l-5.771-7.008Z",
    transform: "translate(4.484 1.407)",
    fill: "#fbfbfc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3647",
    "data-name": "Path 3647",
    d: "M21.034,14.153a10.376,10.376,0,0,0-1.924-1.512h0a10.376,10.376,0,0,0,1.924-1.512,14.293,14.293,0,0,0,4.4-8.245,2.784,2.784,0,0,0-.55-2.061A2.306,2.306,0,0,0,22.957,0a2.361,2.361,0,0,0-2.336,2.061,11.242,11.242,0,0,1-2.611,5.084,7.193,7.193,0,0,1-5.222,2.336A7.007,7.007,0,0,1,7.567,7.008,11.242,11.242,0,0,1,4.957,1.924,2.778,2.778,0,0,0,2.483,0h0A2.4,2.4,0,0,0,.559.962,2.629,2.629,0,0,0,.01,3.023a14.293,14.293,0,0,0,4.4,8.245,10.376,10.376,0,0,0,1.924,1.512h0a10.376,10.376,0,0,0-1.924,1.512,14.293,14.293,0,0,0-4.4,8.245A2.784,2.784,0,0,0,.559,24.6a2.4,2.4,0,0,0,1.924.962A2.361,2.361,0,0,0,4.819,23.5,11.242,11.242,0,0,1,7.43,18.413a7.193,7.193,0,0,1,5.222-2.336,7.007,7.007,0,0,1,5.222,2.473,11.242,11.242,0,0,1,2.611,5.084A2.469,2.469,0,0,0,22.82,25.7h0a2.4,2.4,0,0,0,1.924-.962,2.784,2.784,0,0,0,.55-2.061A13.722,13.722,0,0,0,21.034,14.153Z",
    transform: "translate(0.026)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("text", {
    id: "By",
    transform: "translate(322 1098.75)",
    fill: "#fbfbfc",
    fontSize: 16,
    fontFamily: "Oxygen-Bold, Oxygen",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "by")), /*#__PURE__*/React.createElement("g", {
    id: "Visma-logo-color-rgb",
    transform: "translate(347.306 1087.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17760",
    "data-name": "Path 17760",
    d: "M8.761,0c4.644.343,9.77,2.38,12.7,5.275,3.743,3.706,2.452,7.4-2.88,8.268S5.881,12.106,2.138,8.4C-.726,5.565-.642,2.736,1.947,1.147L16.8,10.629Z",
    fill: "#e70641"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17761",
    "data-name": "Path 17761",
    d: "M107.38,13.409,105,7.006a20.125,20.125,0,0,1-.74-2.278h0a18.069,18.069,0,0,1-.62,2.317l-2.47,6.364H96.85L102.51.08h3.3l5.91,13.329Z",
    transform: "translate(-16.038 0.315)",
    fill: "#fbfbfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17762",
    "data-name": "Path 17762",
    d: "M42.92.08l2.44,6.4a18.318,18.318,0,0,1,.73,2.285h0a17.841,17.841,0,0,1,.63-2.317L49.23.08h4.23L47.8,13.409H44.49L38.59.08Z",
    transform: "translate(-14.067 0.078)",
    fill: "#fbfbfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17763",
    "data-name": "Path 17763",
    d: "M60.52.08V13.409h-4V.08Z",
    transform: "translate(-14.157 0.078)",
    fill: "#fbfbfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17764",
    "data-name": "Path 17764",
    d: "M83.34.08l2,7.866h.05L87,.08h5.42l2.13,13.329H90.41l-1-9.6h-.05l-.65,3.264L87,13.409H83.88l-2-6.384-.68-2.97V3.807h0l-.62,9.6H76.24L78,.08Z",
    transform: "translate(-15.708 0.158)",
    fill: "#fbfbfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17765",
    "data-name": "Path 17765",
    d: "M70.53.08A3.674,3.674,0,0,0,69,1.516c-1.11,1.664,0,2.937,1,4.066.14.163.3.333.44.5,2.17,2.434,3,4.229,1.41,6.793-.12.176-.38.522-.38.522H66.62a4.051,4.051,0,0,0,1.49-1.259c1.11-1.755-.2-3.367-1.48-4.921C65.1,5.346,63.51,3.408,65.19.759A7.984,7.984,0,0,1,65.7.106Z",
    transform: "translate(-15.114 0.158)",
    fill: "#fbfbfc"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIxVismaWhiteLogo);
export default __webpack_public_path__ + "static/media/ix-visma-white-logo.c6d91c244407a229dd710c2be6b9767b.svg";
export { ForwardRef as ReactComponent };